<app-form-input [parentForm]="parentForm" [disabled]="disabled" [label]="step9.getspan16" [type]="'radio'"
	[rule]="'pattern_29'" [value]="radioButtonValue" [name]="radioButtonCtrlName" [radios]="[
						{
                            value: '',
							label: step9.gettypecrjugement
						},
                        {
                            value: criterecdc,
							label: step9.getcriterecdc
						},
                        {
                            value: criterepondere,
							label: step9.getcriterepondere
						},
						{
                            value: criterelibre,
							label: step9.getcriterelibre
						},
						{
                            value: critereprix,
							label: step9.getcritereprix
						}
    ]">
</app-form-input>

<div *ngIf="isCriterePondere()">
	<button class="btn btn-outline-primary" (click)="addcriterePondere()">{{ step9.add | translate }}</button>
	<div *ngFor="let obj of criteres.criterePondere; let i = index">
		<fieldset>
			<legend></legend>
			<button *ngIf="i !== 0" class="btn btn-outline-primary" (click)="removecriterePondere(i)">{{ step9.remove | translate
				}}</button>
			<app-critere-pondere [uid]="getUid()+'_index_'+(i+1)" [parentForm]="parentForm" [disabled]="disabled"
				[criterePondere]="obj" [iteration]="i+1"></app-critere-pondere>
		</fieldset>
	</div>
	<app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg1" [id]="getStepId() + rg1"></app-form-input-error>
	<app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg2" [id]="getStepId() + rg2"></app-form-input-error>
</div>

<div *ngIf="isCritereLibre()">
	<app-form-input [label]="step9.getcriterelibrevide" [name]="getUid() + '_SepAtt_critereLibre'"
		[parentForm]="parentForm" [disabled]="disabled" [type]="'chips'" [rule]="'minCaractere_3|maxCaractere_1000'"
		[value]="criteres.critereLibre">
	</app-form-input>
	<app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg3" [id]="getStepId() + rg3"></app-form-input-error>
</div>


<!--<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="criteres.criterePrix" 
 
[label]="step9.getcritereprix"
[type]="'text'" [rule]="''"
[name]="getUid()+'_SepAtt_criterePrix'">
</app-form-input>-->